import axios from 'axios'

// Create an Axios instance with the base URL from environment variables
const apiClient = axios.create({
  baseURL: process.env.REACT_APP_DMQT_API_HOST,
})

// Function to handle errors uniformly
const handleError = (error) => {
  if (error.response) {
    console.error(
      `API Error: ${error.response.status} - ${error.response.statusText}`
    )
  } else if (error.request) {
    console.error('No response received from API:', error.request)
  } else {
    console.error('Error setting up request:', error.message)
  }
  throw error // Re-throw to allow calling functions to handle it
}

// GET request function
// Added optional customHeaders parameter, merging with existing code
export const getData = async (endpoint, customHeaders = {}) => {
  try {
    // console.log('Custom headers (GET):', customHeaders)
    const response = await apiClient.get(endpoint, {
      headers: {
        ...customHeaders,
      },
    })
    if (response.status !== 200) {
      throw new Error(`Unexpected status code: ${response.status}`)
    }
    return response.data
  } catch (error) {
    handleError(error)
  }
}

// POST request function
// Added optional customHeaders parameter, merging with existing code
export const postData = async (endpoint, data, customHeaders = {}) => {
  try {
    // console.log('Custom headers (POST):', customHeaders)
    const response = await apiClient.post(endpoint, data, {
      headers: {
        ...customHeaders,
      },
    })
    if (response.status !== 200) {
      throw new Error(`Unexpected status code: ${response.status}`)
    }
    return response.data
  } catch (error) {
    handleError(error)
  }
}
